module.exports = __webpack_public_path__ + "static/media/img_connect01.51e5231a.jpg";